module.exports = __webpack_public_path__ + "img/events-5.e5c098d0.jpg";